var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('b-row',[_vm._t("infoHeader"),_vm._t("info")],2)],1),_c('b-col',{staticClass:"my-2",attrs:{"cols":"12"}},[(_vm.mostrarFormFilter)?_vm._t("form"):_vm._e(),_vm._t("filtroAplicado")],2),_vm._t("formFooter")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }